'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('./paths');

var _index = require('./index');

var _paths2 = require('../feiseanna/paths');

var _index2 = require('../scores/index');

exports.default = function (sid, fid) {
  return function (dispatch, getState) {

    var promise = Promise.resolve();
    var schoolStudents = (0, _paths.getSchoolCompetitors)(getState(), sid, fid);

    if (!schoolStudents || !(schoolStudents.every(function (pid) {
      return (0, _paths2.getFlagsForPerson)(getState(), fid, pid);
    }).size > 0)) {
      promise = dispatch((0, _index.getCompetitorsForSchool)(sid, fid));
    };

    return promise.then(function () {
      return (0, _paths.getSchoolCompetitors)(getState(), sid).filter(function (pid) {
        return (0, _paths2.getFlagsForPerson)(getState(), fid, pid).getIn(['registered']);
      }).map(function (pid) {
        return dispatch((0, _index2.getScores)(pid, fid));
      });
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/schools/getScores.js
// module id = 670
// module chunks = 0